module.exports = {"title":"Get in touch or Contact us","contact_hotline":"044-45534533","contact_hotline_link":"04445534533","meta":{"description":"Let us know how we help/improve and we will get back to you within 24 hours. 044-45534533 / info@gogovan.co.in.","og:image":"/img/aboutus-banner.jpg","og:title":"Get in touch or Contact us","og:url":"{{SITE_HTTP_URL}}/contact","og:description":"Let us know how we help/improve and we will get back to you within 24 hours. 044-45534533 / info@gogovan.co.in.","og:type":"website","og:site_name":"GoGoVan"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/in/setting/contact/locale.json
// module id = 641
// module chunks = 0 1 2 3 4 5